const catagory_types = {
    GET_CATAGORIES: 'GET_CATAGORIES',
    SET_CATAGORIES: 'SET_CATAGORIES',
}

export default catagory_types;